<template>
	<div class="people_item" @click="$emit('click')">
		<cl-avatar :src="item.avatar" width="40" height="40"></cl-avatar>
		<div class="people_item_info">
			<h3 class="people_item_name SysFontM">{{item['name' + $lang]}}</h3>
			<p class="people_item_date_wrapper" v-if="item.date">
				<cl-svg-icon class="people_item_date_icon" icon-class="time" style="color: #81818A;"></cl-svg-icon>
				<span class="people_item_date AkrobatM">{{item.date}}</span>
			</p>
		</div>
		<div class="people_item_score SysFontM">{{item.score}}</div>
	</div>
</template>

<script>
	export default {
		name: 'cl-eval-people-item',
		props: {
			item: {
				type: Object,
				default: () => ({
					name: 'sahdlasjlkfd',
                    date: '2022/20/29',
                    number: '24',
                    score: '90'
				})
			}
		},

		methods: {
				
		}

	}
</script>

<style lang="scss" scoped>
	.people_item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 261px;
		height: 83px;
		padding-left: 16px;
		box-sizing: border-box;
		border-bottom: 1px solid #E9EDF3;
		background: #fff;
		&:hover {
			border-radius: 6px;
			overflow: hidden;
			background: linear-gradient(89.86deg, #5581FF 0.01%, #0042E1 99.96%);
			.people_item_name, .people_item_date, .people_item_date_icon, .people_item_score {
				color: #fff!important;
			}
			.people_item_score {
				background: linear-gradient(180deg, #0949e4 0%, #073dc2 100%);
			}
		}
		.cl_avatar {
			filter: drop-shadow(0px 6px 8px rgba(54, 99, 225, 0.16));
		}
		.people_item_info {
			flex: 1;
			margin-left: 20px;
			.people_item_name {
				font-size: 16px;
				line-height: 22px;
				color: #3A3A3A;
			}
			.people_item_date_wrapper {
				margin-top: 8px;
				
				.people_item_date {
					font-size: 14px;
					line-height: 17px;
					color: #3663E1;
					margin-left: 8px;
				}
			}
		}
		.people_item_score {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 40px;
			height: 100%;
			background: linear-gradient(180deg, rgba(248, 248, 248, 0) 0%, #F7F7F7 100%);
			color: #EB0000;
			font-size: 16px;
			line-height: 22px;
		}
	}
</style>